import { createStyles, Theme } from "@material-ui/core";

export const styles = (theme: Theme) =>
  createStyles({
    container: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      padding: 20,
    },
    dialogPaper: {
      borderRadius: 35,
    },
    btnContaniner: {
      display: "flex",
      justifyContent: "center",
      width: "100%",
      marginBottom: 12,
    },
    button: {
      borderRadius: 15,
      textTransform: "none",
      backgroundColor: theme.palette.primary.main,
      color: "#ffffff",
      margin: "0 16px",
    },
    title: {
      paddingTop: 5,
      textAlign: "center",
    },
    imageContainer: {
      backgroundColor: theme.palette.primary.main,
      borderRadius: 15,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100%",
    },
    image: {
      maxWidth: "100%",
      height: "auto",
    },
    textContent: {
      fontWeight: "bold",
      textAlign: "center",
      fontSize: "clamp(1rem, 1vw, 1.1rem)",
    },
  });
